// extracted by mini-css-extract-plugin
module.exports = {"card":"multiCountColumns_card__24Hon"};